export default "__VITE_ASSET__616a076a__"